import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { TimeAgo } from "@kanda-libs/ks-design-library";
import type { FormattedFinanceStatus, FormattedStatus } from "components/job/JobTable/types";
import { CLASS_NAMES, HIGHLIGHT_PROPS } from "components/job/JobTable/Activity/constants";
import useActivityProps from "components/job/JobTable/Activity/useActivityProps";

export interface ActivityProps {
  date: string;
  status: FormattedStatus;
  financeStatus: FormattedFinanceStatus;
  archived: string;
}

export const Activity: FunctionComponent<ActivityProps> = (props) => {
  const { timestamp, label, searchWords, status, financeStatus } =
    useActivityProps(props);

  return (
    <div className="flex flex-col">
      <p className={CLASS_NAMES.label}>
        <span>{label}</span> <TimeAgo timestamp={timestamp} />
      </p>
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={status || ""}
        className="text-12-18 text-neutral-900"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={financeStatus || ""}
        className="text-12-18 text-neutral-900"
      />
    </div>
  );
};
